import { getPointLeftPercent } from "~/feature/chart/utils";

import { BAR_WIDTH_RATIO, MIN_BAR_HEIGHT_PERCENT } from "./constants";

export interface IVolumeBar {
  key: number;
  leftPercent: number;
  heightPercent: number;
}

export const buildVolumeBars = (
  volumeByTimeline: (number | null)[]
): IVolumeBar[] => {
  const max = Math.max(...volumeByTimeline.map((value) => value ?? 0), 0);

  if (max <= 0) {
    return [];
  }

  return volumeByTimeline.flatMap((value, index) =>
    value === null
      ? []
      : [
          {
            key: index,
            leftPercent: getPointLeftPercent(index, volumeByTimeline.length),
            heightPercent: Math.max(
              (value / max) * 100,
              value > 0 ? MIN_BAR_HEIGHT_PERCENT : 0
            ),
          },
        ]
  );
};

export const getBarWidthPercent = (pointsCount: number): number =>
  pointsCount <= 1
    ? BAR_WIDTH_RATIO * 100
    : (100 / (pointsCount - 1)) * BAR_WIDTH_RATIO;
